import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type SetGrowerBenchmarkFirmProfileMutationVariables = Types.Exact<{
  input: Types.SetGrowerBenchmarkFirmProfileInput;
}>;


export type SetGrowerBenchmarkFirmProfileMutation = { __typename?: 'Mutation', setGrowerBenchmarkFirmProfile: { __typename?: 'GrowerBenchmarkFirmProfilePayload', profile?: { __typename?: 'GrowerBenchmarkFirmProfile', communityId: string, firmId: string, displayName: string, tags: Array<string>, ticker?: string | null, checklist: Array<{ __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetGrowerBenchmarkFirmChecklistItemMutationVariables = Types.Exact<{
  input: Types.SetGrowerBenchmarkFirmChecklistItemInput;
}>;


export type SetGrowerBenchmarkFirmChecklistItemMutation = { __typename?: 'Mutation', setGrowerBenchmarkFirmChecklistItem: { __typename?: 'GrowerBenchmarkFirmProfilePayload', profile?: { __typename?: 'GrowerBenchmarkFirmProfile', communityId: string, firmId: string, displayName: string, tags: Array<string>, ticker?: string | null, checklist: Array<{ __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type BeginGrowerBenchmarkFirmLookupMutationVariables = Types.Exact<{
  input: Types.BeginGrowerBenchmarkFirmLookupInput;
}>;


export type BeginGrowerBenchmarkFirmLookupMutation = { __typename?: 'Mutation', beginGrowerBenchmarkFirmLookup: { __typename?: 'GrowerBenchmarkFirmLookupPayload', lookup?: { __typename?: 'GrowerBenchmarkFirmLookup', reason: string, openedAt: Types.TDateISO, firm: { __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }, profile: { __typename?: 'GrowerBenchmarkFirmProfile', communityId: string, firmId: string, displayName: string, tags: Array<string>, ticker?: string | null, checklist: Array<{ __typename?: 'GrowerBenchmarkOnboardingChecklistItem', itemKey: string, isComplete: boolean, completedByUserId?: string | null, completedAt?: Types.TDateISO | null }> }, submissions: Array<{ __typename?: 'GrowerBenchmarkSubmission', submissionId: string, communityId: string, firmId: string, reportingUnitId: string, periodId: string, version: number, status: Types.GrowerBenchmarkSubmissionStatus, submittedByUserId: string, submittedAt?: Types.TDateISO | null, approvalType?: Types.GrowerBenchmarkApprovalType | null, approvedByUserId?: string | null, approvedAt?: Types.TDateISO | null, supersededBySubmissionId?: string | null }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type SetGrowerBenchmarkRosterEntryMutationVariables = Types.Exact<{
  input: Types.SetGrowerBenchmarkRosterEntryInput;
}>;


export type SetGrowerBenchmarkRosterEntryMutation = { __typename?: 'Mutation', setGrowerBenchmarkRosterEntry: { __typename?: 'GrowerBenchmarkCommunityPayload', community?: { __typename?: 'GrowerBenchmarkCommunity', communityId: string, name: string, segment: Types.GrowerBenchmarkCommunitySegment, tags: Array<string>, firms: Array<{ __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }>, roster: Array<{ __typename?: 'GrowerBenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.GrowerBenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type RevokeGrowerBenchmarkRosterEntryMutationVariables = Types.Exact<{
  input: Types.RevokeGrowerBenchmarkRosterEntryInput;
}>;


export type RevokeGrowerBenchmarkRosterEntryMutation = { __typename?: 'Mutation', revokeGrowerBenchmarkRosterEntry: { __typename?: 'GrowerBenchmarkCommunityPayload', community?: { __typename?: 'GrowerBenchmarkCommunity', communityId: string, name: string, segment: Types.GrowerBenchmarkCommunitySegment, tags: Array<string>, firms: Array<{ __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }>, roster: Array<{ __typename?: 'GrowerBenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.GrowerBenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };

export type AcceptGrowerBenchmarkAcceptableUseMutationVariables = Types.Exact<{
  input: Types.AcceptGrowerBenchmarkAcceptableUseInput;
}>;


export type AcceptGrowerBenchmarkAcceptableUseMutation = { __typename?: 'Mutation', acceptGrowerBenchmarkAcceptableUse: { __typename?: 'GrowerBenchmarkCommunityPayload', community?: { __typename?: 'GrowerBenchmarkCommunity', communityId: string, name: string, segment: Types.GrowerBenchmarkCommunitySegment, tags: Array<string>, firms: Array<{ __typename?: 'GrowerBenchmarkFirm', firmId: string, tenantId: string, label: string, isActive: boolean, classification: Array<{ __typename?: 'GrowerBenchmarkClassificationFacet', key: string, value: string }>, reportingUnits: Array<{ __typename?: 'GrowerBenchmarkReportingUnit', reportingUnitId: string, label: string, cadence: Types.GrowerBenchmarkReportingCadence }> }>, roster: Array<{ __typename?: 'GrowerBenchmarkRosterEntry', rosterEntryId: string, userId: string, role: Types.GrowerBenchmarkRosterRole, basis: string, startsAt: Types.TDateISO, endsAt?: Types.TDateISO | null, acceptableUseAcceptedAt?: Types.TDateISO | null, acceptableUseVersion?: string | null, isEffective: boolean }> } | null, errors?: Array<{ __typename?: 'ValidationError', code?: string | null, message: string }> | null } };


export const SetGrowerBenchmarkFirmProfileDocument = new TypedDocumentString(`
    mutation SetGrowerBenchmarkFirmProfile($input: SetGrowerBenchmarkFirmProfileInput!) {
  setGrowerBenchmarkFirmProfile(input: $input) {
    profile {
      ...GrowerBenchmarkFirmProfileFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkFirmProfileFields on GrowerBenchmarkFirmProfile {
  communityId
  firmId
  displayName
  tags
  ticker
  checklist {
    ...GrowerBenchmarkOnboardingChecklistItemFields
  }
}
fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}`);
export const SetGrowerBenchmarkFirmChecklistItemDocument = new TypedDocumentString(`
    mutation SetGrowerBenchmarkFirmChecklistItem($input: SetGrowerBenchmarkFirmChecklistItemInput!) {
  setGrowerBenchmarkFirmChecklistItem(input: $input) {
    profile {
      ...GrowerBenchmarkFirmProfileFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkFirmProfileFields on GrowerBenchmarkFirmProfile {
  communityId
  firmId
  displayName
  tags
  ticker
  checklist {
    ...GrowerBenchmarkOnboardingChecklistItemFields
  }
}
fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}`);
export const BeginGrowerBenchmarkFirmLookupDocument = new TypedDocumentString(`
    mutation BeginGrowerBenchmarkFirmLookup($input: BeginGrowerBenchmarkFirmLookupInput!) {
  beginGrowerBenchmarkFirmLookup(input: $input) {
    lookup {
      ...GrowerBenchmarkFirmLookupFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkFirmProfileFields on GrowerBenchmarkFirmProfile {
  communityId
  firmId
  displayName
  tags
  ticker
  checklist {
    ...GrowerBenchmarkOnboardingChecklistItemFields
  }
}
fragment GrowerBenchmarkOnboardingChecklistItemFields on GrowerBenchmarkOnboardingChecklistItem {
  itemKey
  isComplete
  completedByUserId
  completedAt
}
fragment GrowerBenchmarkFirmLookupFields on GrowerBenchmarkFirmLookup {
  firm {
    ...GrowerBenchmarkFirmFields
  }
  profile {
    ...GrowerBenchmarkFirmProfileFields
  }
  submissions {
    ...GrowerBenchmarkSubmissionFields
  }
  reason
  openedAt
}
fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkSubmissionFields on GrowerBenchmarkSubmission {
  submissionId
  communityId
  firmId
  reportingUnitId
  periodId
  version
  status
  submittedByUserId
  submittedAt
  approvalType
  approvedByUserId
  approvedAt
  supersededBySubmissionId
}`);
export const SetGrowerBenchmarkRosterEntryDocument = new TypedDocumentString(`
    mutation SetGrowerBenchmarkRosterEntry($input: SetGrowerBenchmarkRosterEntryInput!) {
  setGrowerBenchmarkRosterEntry(input: $input) {
    community {
      ...GrowerBenchmarkCommunityFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkCommunityFields on GrowerBenchmarkCommunity {
  communityId
  name
  segment
  tags
  firms {
    ...GrowerBenchmarkFirmFields
  }
  roster {
    ...GrowerBenchmarkRosterEntryFields
  }
}
fragment GrowerBenchmarkRosterEntryFields on GrowerBenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}`);
export const RevokeGrowerBenchmarkRosterEntryDocument = new TypedDocumentString(`
    mutation RevokeGrowerBenchmarkRosterEntry($input: RevokeGrowerBenchmarkRosterEntryInput!) {
  revokeGrowerBenchmarkRosterEntry(input: $input) {
    community {
      ...GrowerBenchmarkCommunityFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkCommunityFields on GrowerBenchmarkCommunity {
  communityId
  name
  segment
  tags
  firms {
    ...GrowerBenchmarkFirmFields
  }
  roster {
    ...GrowerBenchmarkRosterEntryFields
  }
}
fragment GrowerBenchmarkRosterEntryFields on GrowerBenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}`);
export const AcceptGrowerBenchmarkAcceptableUseDocument = new TypedDocumentString(`
    mutation AcceptGrowerBenchmarkAcceptableUse($input: AcceptGrowerBenchmarkAcceptableUseInput!) {
  acceptGrowerBenchmarkAcceptableUse(input: $input) {
    community {
      ...GrowerBenchmarkCommunityFields
    }
    errors {
      code
      message
    }
  }
}
    fragment GrowerBenchmarkFirmFields on GrowerBenchmarkFirm {
  firmId
  tenantId
  label
  isActive
  classification {
    ...GrowerBenchmarkClassificationFacetFields
  }
  reportingUnits {
    ...GrowerBenchmarkReportingUnitFields
  }
}
fragment GrowerBenchmarkClassificationFacetFields on GrowerBenchmarkClassificationFacet {
  key
  value
}
fragment GrowerBenchmarkReportingUnitFields on GrowerBenchmarkReportingUnit {
  reportingUnitId
  label
  cadence
}
fragment GrowerBenchmarkCommunityFields on GrowerBenchmarkCommunity {
  communityId
  name
  segment
  tags
  firms {
    ...GrowerBenchmarkFirmFields
  }
  roster {
    ...GrowerBenchmarkRosterEntryFields
  }
}
fragment GrowerBenchmarkRosterEntryFields on GrowerBenchmarkRosterEntry {
  rosterEntryId
  userId
  role
  basis
  startsAt
  endsAt
  acceptableUseAcceptedAt
  acceptableUseVersion
  isEffective
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    SetGrowerBenchmarkFirmProfile: build.mutation<SetGrowerBenchmarkFirmProfileMutation, SetGrowerBenchmarkFirmProfileMutationVariables>({
      query: (variables) => ({ document: SetGrowerBenchmarkFirmProfileDocument, variables })
    }),
    SetGrowerBenchmarkFirmChecklistItem: build.mutation<SetGrowerBenchmarkFirmChecklistItemMutation, SetGrowerBenchmarkFirmChecklistItemMutationVariables>({
      query: (variables) => ({ document: SetGrowerBenchmarkFirmChecklistItemDocument, variables })
    }),
    BeginGrowerBenchmarkFirmLookup: build.mutation<BeginGrowerBenchmarkFirmLookupMutation, BeginGrowerBenchmarkFirmLookupMutationVariables>({
      query: (variables) => ({ document: BeginGrowerBenchmarkFirmLookupDocument, variables })
    }),
    SetGrowerBenchmarkRosterEntry: build.mutation<SetGrowerBenchmarkRosterEntryMutation, SetGrowerBenchmarkRosterEntryMutationVariables>({
      query: (variables) => ({ document: SetGrowerBenchmarkRosterEntryDocument, variables })
    }),
    RevokeGrowerBenchmarkRosterEntry: build.mutation<RevokeGrowerBenchmarkRosterEntryMutation, RevokeGrowerBenchmarkRosterEntryMutationVariables>({
      query: (variables) => ({ document: RevokeGrowerBenchmarkRosterEntryDocument, variables })
    }),
    AcceptGrowerBenchmarkAcceptableUse: build.mutation<AcceptGrowerBenchmarkAcceptableUseMutation, AcceptGrowerBenchmarkAcceptableUseMutationVariables>({
      query: (variables) => ({ document: AcceptGrowerBenchmarkAcceptableUseDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useSetGrowerBenchmarkFirmProfileMutation, useSetGrowerBenchmarkFirmChecklistItemMutation, useBeginGrowerBenchmarkFirmLookupMutation, useSetGrowerBenchmarkRosterEntryMutation, useRevokeGrowerBenchmarkRosterEntryMutation, useAcceptGrowerBenchmarkAcceptableUseMutation } = injectedRtkApi;
